import { LocationTypes } from '../constants';

const formatDirectFlightSearchRequest = (flightSegments = []) => {
  const request = {};

  flightSegments.forEach((fs, index) => {
    if (!fs) return;

    const segmentKey = `request.segments[${index}]`;

    if (fs.departureDate) {
      request[`${segmentKey}.departureDate`] = fs.departureDate;
    }

    // if (fs.arrivalDate) {
    //   request[`${segmentKey}.arrivalDate`] = fs.arrivalDate;
    // }

    if (fs.flightNumber) {
      request[`${segmentKey}.flightNumber`] = fs.flightNumber;
    }

    if (fs.cabin) {
      request[`${segmentKey}.classOfService`] = fs.cabin.toUpperCase();
    }

    if (fs.carrierCode?.value) {
      request[`${segmentKey}.carrierCode`] = fs.carrierCode?.value;
    }
    const originLocation = fs.origin;
    if (originLocation) {
      if (originLocation.value) {
        if (originLocation.locationType === LocationTypes.PORT_OF_DEPARTURE) {
          request[`${segmentKey}.origin.departureCityId`] = originLocation.value;
        } else if (originLocation.airportCode && originLocation.airportCode.trim() !== '') {
          request[`${segmentKey}.origin.airportCode`] = originLocation.airportCode;
        } else {
          request[`${segmentKey}.origin.geoIndex`] = originLocation.value;
          if (originLocation.featureClass) request[`${segmentKey}.origin.featureClass`] = originLocation.featureClass;
        }
      }
      if (originLocation.airportCode) request[`${segmentKey}.origin.airportCode`] = originLocation.airportCode;
      if (originLocation.latitude) request[`${segmentKey}.origin.latitude`] = originLocation.latitude;
      if (originLocation.longitude) request[`${segmentKey}.origin.longitude`] = originLocation.longitude;
    }

    const destinationLocation = fs.destination;
    if (destinationLocation) {
      if (destinationLocation.value) {
        if (destinationLocation.locationType === LocationTypes.PORT_OF_DEPARTURE) {
          request[`${segmentKey}.destination.departureCityId`] = destinationLocation.value;
        } else if (destinationLocation.airportCode && destinationLocation.airportCode.trim() !== '') {
          request[`${segmentKey}.destination.airportCode`] = destinationLocation.airportCode;
        } else {
          request[`${segmentKey}.destination.geoIndex`] = destinationLocation.value;
          if (destinationLocation.featureClass) request[`${segmentKey}.destination.featureClass`] = destinationLocation.featureClass;
        }
      }
      if (destinationLocation.airportCode) request[`${segmentKey}.destination.airportCode`] = destinationLocation.airportCode;
      if (destinationLocation.latitude) request[`${segmentKey}.destination.latitude`] = destinationLocation.latitude;
      if (destinationLocation.longitude) request[`${segmentKey}.destination.longitude`] = destinationLocation.longitude;
    }
  });

  return request;
};

export default formatDirectFlightSearchRequest;
